import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ButtonComponent,
  ButtonStyling,
} from '../../../../components/form/elements/button';
import ValidationModal from './validation-modal';
import ValidationTable from './validation-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import css from '../index.module.css';

interface Props {
  conditions: any[];
  fieldName: string;
  onClose: () => void;
}

export default function ValidationModalContainer({
  conditions,
  fieldName,
  onClose,
}: Props) {
  const { t } = useTranslation();
  const transKeyPrefix = 'pages.crop.vaad_liz_reports_v2.';
  const tp = useCallback((key: string) => t(transKeyPrefix.concat(key)), [t]);

  return (
    <div className={css['validation-modal']}>
      <ValidationModal
        content={
          <>
            <h2>
              {tp('validation.modal.ecoschemes_criteria')}
              ,&nbsp;
              {fieldName}
            </h2>
            <div className={css['warning']}>
              <FontAwesomeIcon icon={faQuestionCircle} />
              {tp('validation.modal.warning')}
            </div>
            <ValidationTable data={conditions} title={null} />
          </>
        }
        buttons={[
          <ButtonComponent
            name={'validation-modal-close'}
            key={'validation-modal-close'}
            styling={ButtonStyling.secondary}
            label={tp('validation.modal.close')}
            click={onClose}
          />,
        ]}
        onClose={onClose}
      />
    </div>
  );
}
